/*
  So this component has nothing to do with lazy-loading. Instead, it shows an image by default, and swaps it out once the video is onscreen.
  I don't remember why I did this or what practical purpose it serves. It's used in The Const Deception on mobile, I should do some digging!
*/
import React from 'react';

import useIsOnscreen from '@/hooks/use-is-onscreen';

import VideoGif, { Props as VideoGifProps } from './VideoGif';

interface Props extends VideoGifProps {
  thumbnailSrc: string;
}

function LazyVideoGif({
  width,
  height,
  thumbnailSrc,
  style = {},
  ...delegated
}: Props) {
  const ref = React.useRef(null);
  const isOnscreen = useIsOnscreen(ref);

  const [showVideo, setShowVideo] = React.useState(false);

  const aspectRatio =
    typeof width === 'number' && typeof height === 'number'
      ? `${width} / ${height}`
      : undefined;

  React.useEffect(() => {
    if (isOnscreen) {
      setShowVideo(true);
    }
  }, [isOnscreen]);

  return (
    <div ref={ref}>
      {showVideo ? (
        <VideoGif
          style={{
            aspectRatio,
            ...style,
          }}
          {...delegated}
        />
      ) : (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          alt=""
          src={thumbnailSrc}
          style={{
            aspectRatio,
          }}
        />
      )}
    </div>
  );
}

export default LazyVideoGif;
